import {RootState} from '../../store';
import {ProductFeature} from './types';

export const selectionSelector = (state: RootState): Record<string, ProductFeature> =>
    state['product-features'].selection as Record<string, ProductFeature>;
